export * from './index';



//////////////////
// WEBPACK FOOTER
// ./~/ng2-translate/ng2-translate.js
// module id = 113
// module chunks = 7